<template>
  <b-modal :id="modalId" title="Suggest Contact" hide-footer size="lg">
    <div class="table-responsive mb-0">
      <table class="table mb-0 table-centered">
        <thead class="thead-light">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th v-if="whatsapp">WhatsApp</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="contact in contactsToShow">
          <td>{{ contact.first_name }} {{ contact.last_name }}</td>
          <td>{{ contact.email ? contact.email : '-' }}</td>
          <td>{{ contact.phone_number ? contact.phone_number : '-' }}</td>
          <td v-if="whatsapp"><i class="fa" :class="contact.communicates_via_whatsapp ? 'fa-check text-success' : 'fa-times text-danger'"></i></td>
          <td class="text-right">
            <button
                type="button"
                class="btn btn-itg btn-itg btn-sm"
                @click="selectContact(contact)"
            >
              Select
            </button>
          </td>
        </tr>
        <tr v-if="contactsToShow.length === 0">
         <td colspan="4">
          <span class="text-danger">No contacts to show</span>
         </td>
        </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SuggestContactsModal",
  props: ['modalId', 'hideValues', 'property', 'whatsapp'],
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    ticketContacts() {
      if (this.ticket) {
        return this.ticket.contacts;
      }
      return [];
    },

    contactsToShow() {
      return _.filter(this.ticketContacts, contact => {
        if (this.hideValues) {
          return !this.hideValues.includes(contact[this.property])
        }
        if (this.whatsapp) {
          return contact.communicates_via_whatsapp;
        }
        return true;
      });
    }
  },
  methods: {
    selectContact(contact) {
      this.$emit('contact-selected', contact);
      this.$bvModal.hide(this.modalId);
    }
  }
}
</script>

<style scoped>

</style>